module.exports = __webpack_public_path__ + "img/finger.f99bab5b.gif";